/**
 * RobotContext - Manages robot connection state
 * 
 * Handles:
 * - Robot client instance
 * - Robot files list
 * - Connection settings
 */
import { createContext, useContext, useState, useEffect } from 'react';
import { RobotClient } from '../robot/RobotClient.js';

const RobotContext = createContext(null);

export const useRobot = () => {
  const context = useContext(RobotContext);
  if (!context) {
    throw new Error('useRobot must be used within RobotProvider');
  }
  return context;
};

export const RobotProvider = ({ children, onServerAvailabilityChange }) => {
  const [robotClient] = useState(() => new RobotClient());
  const [robotFiles, setRobotFiles] = useState([]);
  const [robotConnection, setRobotConnection] = useState({ 
    host: '', 
    username: '', 
    password: '', 
    type: 'ssh' 
  });

  // Check server availability on mount
  useEffect(() => {
    const checkServer = async () => {
      const available = await robotClient.checkServerAvailability();
      if (onServerAvailabilityChange) {
        onServerAvailabilityChange(available);
      }
    };
    checkServer();
  }, [robotClient, onServerAvailabilityChange]);

  const value = {
    robotClient,
    robotFiles,
    setRobotFiles,
    robotConnection,
    setRobotConnection,
  };

  return <RobotContext.Provider value={value}>{children}</RobotContext.Provider>;
};
